<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">待取药患者</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div class="search">
                    <el-input  placeholder="请输入挂号编号" v-model="serialNumber" clearable style="margin:0 10px 0 0;width:300px">
                        <template slot="prepend">挂号编码</template>
                    </el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getPatient">搜索</el-button>
                </div>
                <el-card class="box-card" shadow='never'>
                    <div slot="header" class="clearfix">
                        <span>患者信息</span>
                    </div>
                    <div class="kong">
                        <span v-show="!patientName">暂无信息</span>
                    </div>
                    <el-row  v-show="patientName">
                        <el-col :span="12" class="item">
                            <el-input v-model="patientName" disabled>
                                <template slot="prepend">患者姓名</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="name" disabled>
                                <template slot="prepend">药品项目</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="medicinerName" disabled>
                                <template slot="prepend">就诊医生</template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" class="item">
                            <el-input v-model="balance" disabled>
                                <template slot="prepend">患者余额</template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-card>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Add",
        data() {
            return {

                loading: false,
                add_waresCode:'',
                pageSize:20,
                currentPage:1,
                tableData:[],
                status:'',
                visitType:"",
                serialNumber:"",
                patientName:"",
                registerCode:"",
                name:'',
                code:'',
                patientCode:'',
                medicinerName:'',
                balance:'',
            }
        },

        methods: {
            init(){
                this.serialNumber=''
                this.patientName=''
                this.medicinerName=''
                this.balance=''
                this.name=''
            },
            closeSelf() {
                this.$emit("closeAdd");
            },
            confirm(){
                if(!this.tableData.length){
                    this.$message.error('请选择患者')
                    return
                }
                this.closeSelf();
                this.$emit('getList',this.tableData,this.serialNumber)
            },
            changeWares(selVal){
                this.add_waresCode=selVal;
            },
            getPatient(){
                if(!this.serialNumber){
                    this.$message.error('请输入挂号编码')
                    return
                }
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'PrescriptionDrug/getNotCheck',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        serialNumber:this.serialNumber,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data= response.data.data;
                        this.tableData=data
                        this.patientName=data[0].consultationRecordDTO.patient.name;
                        this.medicinerName=data[0].consultationRecordDTO.medicinerName;
                        this.balance=data[0].consultationRecordDTO.patient.balance;
                        this.name=data[0].prescriptionDrugDTO.name;
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>

<style  lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

    .modal {
        background-color: #fff;
        box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width:700px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .search{
        display: flex;
        justify-content: center;
    }
    .box-card{
        margin: 20px;
    }
    .kong{
        display: flex;
        justify-content: center;
        color: #999;
    }
    .modal-body {
        position: relative;
        padding: 20px 20px;
        z-index: 99;
        height: 100%;
    }
    .modal-body /deep/  .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        border-color: #E4E7ED;
        color: #000;
        cursor: not-allowed;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content:center;
        padding: 15px;
        display: flex;
        .el-button{
            width: 15%;
            font-size: 16px;
        }
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding:10px;
    }
    .label{
        padding: 5px 0px;
    }
</style>